import Center from "../Center"

export default function NoLocsHelp() {
    return (
        <Center>
            <p><strong>Add the Legal Officer Cases (LOCs) you need for your use-case.</strong></p>
        </Center>
    );
}
